// Fragment "confirm booking" — the reminder email's Confirm button landing page
// (public/ConfirmBooking.jsx, `/rdv/confirmer?token=`). Contract C2.06. Merged in ./index.js.
export default {
  fr: {
    "confirm.eyebrow": "Confirmation de rendez-vous",
    "confirm.title": "Confirmez votre rendez-vous",
    "confirm.body": "Un tap suffit pour confirmer que vous serez présent·e.",
    "confirm.button": "Confirmer",
    "confirm.doneTitle": "Rendez-vous confirmé",
    "confirm.doneBody": "Merci ! Votre présence est notée. À bientôt.",
    "confirm.missingTokenTitle": "Lien incomplet",
    "confirm.missingTokenBody": "Ce lien ne comporte pas les informations nécessaires. Contactez le cabinet si vous avez besoin d'aide.",
  },
  en: {
    "confirm.eyebrow": "Appointment confirmation",
    "confirm.title": "Confirm your appointment",
    "confirm.body": "One tap confirms you'll be there.",
    "confirm.button": "Confirm",
    "confirm.doneTitle": "Appointment confirmed",
    "confirm.doneBody": "Thank you — you're all set. See you soon.",
    "confirm.missingTokenTitle": "Incomplete link",
    "confirm.missingTokenBody": "This link is missing the information it needs. Contact the practice if you need help.",
  },
  es: {
    "confirm.eyebrow": "Confirmación de cita",
    "confirm.title": "Confirma tu cita",
    "confirm.body": "Con un toque confirmas que asistirás.",
    "confirm.button": "Confirmar",
    "confirm.doneTitle": "Cita confirmada",
    "confirm.doneBody": "Gracias, todo listo. ¡Hasta pronto!",
    "confirm.missingTokenTitle": "Enlace incompleto",
    "confirm.missingTokenBody": "A este enlace le falta la información necesaria. Contacta con la consulta si necesitas ayuda.",
  },
};
